module.exports = __webpack_public_path__ + "img/shop-photo1.d6479a18.jpg";